import React from 'react';
import './Tokenomics.css';

function Tokenomics() {
  const tokenomicsData = [
    { category: "Total Supply", value: "1,000,000,000" },
    { category: "Tax", value: "0/0" },
    { category: "Liquidity", value: "99%" },
    { category: "Marketing", value: "0%" }
  ];

  return (
    <section className="tokenomics-section">
      <h2 className="tokenomics-title">Tokenomics</h2>
      
      <div className="tokenomics-grid">
        {tokenomicsData.map((item, index) => (
          <div key={index} className="tokenomics-card">
            <h3 className="card-title">{item.category}</h3>
            <p className="card-value">{item.value}</p>
          </div>
        ))}
      </div>

      <div className="tokenomics-details">
        <div className="distribution-card">
          <h3>Token Distribution</h3>
          <ul>
            <li>99.99% Initial Liquidity</li>
            <li>0.01% Team Tokens</li>
          </ul>
        </div>
        
        <div className="tax-card">
          <h3>Liquidity Pool Breakdown</h3>
          <ul>
            <li >Updating</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Tokenomics; 